/**
 * Community pinned-post slider (top of Notice/Announcement etc.).
 * Reusable for any page that has .exclusive-pinned-swiper (or custom selector).
 */
const DEFAULT_SELECTOR = '.exclusive-pinned-swiper';

export class PinPostSwiper {
  private readonly selector: string;
  private swiper: unknown = null;

  constructor(selector: string = DEFAULT_SELECTOR) {
    this.selector = selector;
  }

  init(): unknown {
    if (typeof (window as Window & { Swiper?: unknown }).Swiper === 'undefined') return null;

    const el = document.querySelector(this.selector);
    if (!el) return null;

    const SwiperClass = (window as Window & { Swiper: new (el: Element, o: object) => unknown }).Swiper;
    const parent = el.closest('.exclusive-pinned') || document;
    const header =
      el.previousElementSibling?.classList?.contains('exclusive-pinned-header')
        ? el.previousElementSibling
        : null;
    const prevEl =
      header?.querySelector<HTMLElement>('.exclusive-pinned-nav-prev') ??
      parent.querySelector<HTMLElement>('.swiper-button-prev');
    const nextEl =
      header?.querySelector<HTMLElement>('.exclusive-pinned-nav-next') ??
      parent.querySelector<HTMLElement>('.swiper-button-next');
    const pagerEl =
      header?.querySelector<HTMLElement>('.exclusive-pinned-header__pager') ??
      parent.querySelector<HTMLElement>('.swiper-pagination');

    this.swiper = new SwiperClass(el, {
      slidesPerView: 3,
      spaceBetween: 24,
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 12,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
      navigation: prevEl && nextEl
        ? { prevEl, nextEl }
        : undefined,
      pagination: pagerEl
        ? { el: pagerEl, type: 'fraction' }
        : undefined,
    });
    return this.swiper;
  }
}
